/**
 * 預購頁面載入中 skeleton
 */
export function PreorderPageLoading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="animate-pulse space-y-4 w-full max-w-md">
        <div className="h-8 bg-slate-200 rounded w-1/3" />
        <div className="h-48 bg-slate-100 rounded" />
      </div>
    </div>
  );
}
